// import { ContainerModule } from '@patsnap/tahiti-core';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ExportService } from './services/export-service.interface';
import { ExportServiceImpl } from './services/export-service';
import { ExportRepository } from './repositories/export-repository.interface';
import { ExportRepositoryImpl } from './repositories/export-repository';
import { ExportApi } from './repositories/apis/export-api.interface';
import { ExportApiImpl } from './repositories/apis/export-api';
export const detailActions = new ContainerModule(bind => {
    bind(ExportService).to(ExportServiceImpl);
    bind(ExportRepository).to(ExportRepositoryImpl);
    bind(ExportApi).to(ExportApiImpl);
});
